import { render, staticRenderFns } from "./ContactInfoItem.vue?vue&type=template&id=60a7a79d&scoped=true"
import script from "./ContactInfoItem.vue?vue&type=script&lang=js"
export * from "./ContactInfoItem.vue?vue&type=script&lang=js"
import style0 from "./ContactInfoItem.vue?vue&type=style&index=0&id=60a7a79d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a7a79d",
  null
  
)

export default component.exports